import { render, staticRenderFns } from "./SAPBaseCustomerMaterialMappingList.vue?vue&type=template&id=66638f40&scoped=true"
import script from "./SAPBaseCustomerMaterialMappingList.vue?vue&type=script&lang=js"
export * from "./SAPBaseCustomerMaterialMappingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66638f40",
  null
  
)

export default component.exports